export default "__VITE_ASSET__DqeJ7dNF__"